<template>
  <div className="mt-5" fluid>
    <v-divider></v-divider>
    <v-row v-if="isMobile">
      <v-col className="pa-0" md="4" sm="6">
        <v-list>
          <v-list-item>
            <v-list-item-content>
              <v-list-item-subtitle class="d-flex align-center">
                <div class="overflow-hidden overflow-ellipsis">{{ $t('order.customerInfos') }}</div>
                <div v-if="canModifyCustomer" class="pl-2">
                  <v-btn icon x-small @click="showCustomerForm(customer)">
                    <v-icon>mdi-pencil</v-icon>
                  </v-btn>
                </div>
              </v-list-item-subtitle>
              <v-list-item-action-text>
                <span v-if="customer.first_name && customer.last_name">
                  <span v-if="customer.civility">{{ getCivilityTranslation(customer.civility) }}</span>
                  <span>{{ customer.first_name }} {{ customer.last_name }}</span>
                </span>
                <span v-if="customer.erp_customer_id">({{ customer.erp_customer_id }})</span>
              </v-list-item-action-text>
              <v-list-item-action-text v-if="customer.email">
                <span
                  v-if="isDigitalInStoreEnabled"
                  style="text-decoration: underline; cursor: pointer"
                  @click="openClient(customer.email)"
                >
                  {{ customer.email }}
                </span>
                <span v-else>{{ customer.email }}</span>
              </v-list-item-action-text>
              <v-list-item-action-text v-if="customer.phone">{{ customer.phone }}</v-list-item-action-text>
              <v-list-item-action-text v-if="customer.last_four_digit_phone_number">
                {{ customer.last_four_digit_phone_number }}
              </v-list-item-action-text>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-col>

      <v-col v-if="billingAddress" className="pa-0" md="4" sm="6">
        <v-list>
          <v-list-item>
            <v-list-item-content>
              <v-list-item-subtitle class="d-flex align-center">
                <span class="font-weight-black overflow-hidden overflow-ellipsis">
                  {{ $t('order.billingAddress') }}
                </span>
                <div v-if="canModifyAddress" class="pl-2">
                  <v-btn icon x-small @click="showForm(billingAddress, $t('order.billingAddress'), 'billing_address')">
                    <v-icon>mdi-pencil</v-icon>
                  </v-btn>
                </div>
              </v-list-item-subtitle>
              <v-list-item-action-text v-if="billingAddress.company">
                {{ billingAddress.company }}
              </v-list-item-action-text>
              <v-list-item-action-text v-if="billingAddress.last_name && billingAddress.first_name">
                <span v-if="billingAddress.civility">{{ getCivilityTranslation(billingAddress.civility) }}</span>
                <span>{{ billingAddress.first_name }} {{ billingAddress.last_name }}</span>
              </v-list-item-action-text>
              <v-list-item-action-text>{{ billingAddress.street_1 }}</v-list-item-action-text>
              <v-list-item-action-text v-if="billingAddress.street_2">
                {{ billingAddress.street_2 }}
              </v-list-item-action-text>
              <v-list-item-action-text v-if="billingAddress.street_3">
                {{ billingAddress.street_3 }}
              </v-list-item-action-text>
              <v-list-item-action-text>
                {{ billingAddress.postal_code }} {{ billingAddress.city }}
              </v-list-item-action-text>
              <v-list-item-action-text v-if="billingAddress.country_code">
                {{ getTranslatedCountryName(billingAddress.country_code) }}
              </v-list-item-action-text>
              <v-list-item-action-text v-if="billingAddress.phone">{{ billingAddress.phone }}</v-list-item-action-text>
              <v-list-item-subtitle v-if="billingAddress.last_four_digit_phone_number">
                {{ billingAddress.last_four_digit_phone_number }}
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-col>
      <v-col v-if="shippingAddress" className="pa-0" md="4" sm="6">
        <v-list>
          <v-list-item>
            <v-list-item-content>
              <v-list-item-subtitle class="d-flex align-center">
                <span class="font-weight-black overflow-ellipsis overflow-hidden">
                  {{ $t('order.shippingAddress') }}
                </span>
                <div v-if="canModifyAddress" class="pl-2">
                  <v-btn
                    icon
                    x-small
                    @click="showForm(shippingAddress, $t('order.shippingAddress'), 'shipping_address')"
                  >
                    <v-icon>mdi-pencil</v-icon>
                  </v-btn>
                </div>
              </v-list-item-subtitle>
              <v-list-item-action-text v-if="shippingAddress.company">
                {{ shippingAddress.company }}
              </v-list-item-action-text>
              <v-list-item-action-text v-if="shippingAddress.last_name && shippingAddress.first_name">
                <span v-if="shippingAddress.civility">{{ getCivilityTranslation(shippingAddress.civility) }}</span>
                {{ shippingAddress.first_name }} {{ shippingAddress.last_name }}
              </v-list-item-action-text>
              <v-list-item-action-text>{{ shippingAddress.street_1 }}</v-list-item-action-text>
              <v-list-item-action-text v-if="shippingAddress.street_2">
                {{ shippingAddress.street_2 }}
              </v-list-item-action-text>
              <v-list-item-action-text v-if="shippingAddress.street_3">
                {{ shippingAddress.street_3 }}
              </v-list-item-action-text>
              <v-list-item-action-text>
                {{ shippingAddress.postal_code }} {{ shippingAddress.city }}
              </v-list-item-action-text>
              <v-list-item-action-text v-if="shippingAddress.country_code">
                {{ getTranslatedCountryName(shippingAddress.country_code) }}
              </v-list-item-action-text>
              <v-list-item-action-text v-if="shippingAddress.phone">
                {{ shippingAddress.phone }}
              </v-list-item-action-text>
              <v-list-item-subtitle v-if="shippingAddress.last_four_digit_phone_number">
                {{ shippingAddress.last_four_digit_phone_number }}
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-col>
      <v-col v-if="pickingAddress" className="pa-0" md="4" sm="6">
        <v-list>
          <v-list-item>
            <v-list-item-content>
              <v-list-item-subtitle>
                <span class="font-weight-black">{{ $t('order.pickingAddress') }}</span>
              </v-list-item-subtitle>
              <v-list-item-action-text v-if="pickingAddress.company">
                {{ pickingAddress.company }}
              </v-list-item-action-text>
              <v-list-item-action-text v-if="pickingAddress.last_name && pickingAddress.first_name">
                <span v-if="pickingAddress.civility">{{ getCivilityTranslation(pickingAddress.civility) }}</span>
                {{ pickingAddress.first_name }} {{ pickingAddress.last_name }}
              </v-list-item-action-text>
              <v-list-item-action-text>{{ pickingAddress.street_1 }}</v-list-item-action-text>
              <v-list-item-action-text v-if="pickingAddress.street_2">
                {{ pickingAddress.street_2 }}
              </v-list-item-action-text>
              <v-list-item-action-text v-if="pickingAddress.street_3">
                {{ pickingAddress.street_3 }}
              </v-list-item-action-text>
              <v-list-item-action-text>
                {{ pickingAddress.postal_code }} {{ pickingAddress.city }}
              </v-list-item-action-text>
              <v-list-item-action-text v-if="pickingAddress.country_code">
                {{ getTranslatedCountryName(pickingAddress.country_code) }}
              </v-list-item-action-text>
              <v-list-item-action-text v-if="pickingAddress.phone">{{ pickingAddress.phone }}</v-list-item-action-text>
              <v-list-item-subtitle v-if="pickingAddress.last_four_digit_phone_number">
                {{ pickingAddress.last_four_digit_phone_number }}
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-col>
    </v-row>
    <v-row v-else>
      <v-col className="pa-0" md="4" sm="6">
        <v-list>
          <v-list-item>
            <v-list-item-content>
              <v-list-item-title class="d-flex align-center">
                <div class="overflow-hidden overflow-ellipsis">{{ $t('order.customerInfos') }}</div>
                <div v-if="canModifyCustomer" class="pl-2">
                  <v-btn icon x-small @click="showCustomerForm(customer)">
                    <v-icon>mdi-pencil</v-icon>
                  </v-btn>
                </div>
              </v-list-item-title>
              <v-list-item-subtitle>
                <span v-if="customer.first_name && customer.last_name">
                  <span v-if="customer.civility">{{ getCivilityTranslation(customer.civility) }}</span>
                  <span>{{ customer.first_name }} {{ customer.last_name }}</span>
                </span>
                <span v-if="customer.erp_customer_id">({{ customer.erp_customer_id }})</span>
              </v-list-item-subtitle>
              <v-list-item-subtitle v-if="customer.email">
                <span
                  v-if="isDigitalInStoreEnabled"
                  style="text-decoration: underline; cursor: pointer"
                  @click="openClient(customer.email)"
                >
                  {{ customer.email }}
                </span>
                <span v-else>{{ customer.email }}</span>
              </v-list-item-subtitle>
              <v-list-item-subtitle v-if="customer.phone">{{ customer.phone }}</v-list-item-subtitle>
              <v-list-item-subtitle v-if="customer.last_four_digit_phone_number">
                {{ customer.last_four_digit_phone_number }}
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-col>

      <v-col v-if="billingAddress" className="pa-0" md="4" sm="6">
        <v-list>
          <v-list-item>
            <v-list-item-content>
              <v-list-item-title class="d-flex align-center">
                <div class="overflow-hidden overflow-ellipsis">{{ $t('order.billingAddress') }}</div>
                <div v-if="canModifyAddress" class="pl-2">
                  <v-btn icon x-small @click="showForm(billingAddress, $t('order.billingAddress'), 'billing_address')">
                    <v-icon>mdi-pencil</v-icon>
                  </v-btn>
                </div>
              </v-list-item-title>
              <v-list-item-subtitle v-if="billingAddress.company">{{ billingAddress.company }}</v-list-item-subtitle>
              <v-list-item-subtitle v-if="billingAddress.last_name && billingAddress.first_name">
                <span v-if="billingAddress.civility">{{ getCivilityTranslation(billingAddress.civility) }}</span>
                {{ billingAddress.first_name }} {{ billingAddress.last_name }}
              </v-list-item-subtitle>
              <v-list-item-subtitle>{{ billingAddress.street_1 }}</v-list-item-subtitle>
              <v-list-item-subtitle v-if="billingAddress.street_2">{{ billingAddress.street_2 }}</v-list-item-subtitle>
              <v-list-item-subtitle v-if="billingAddress.street_3">{{ billingAddress.street_3 }}</v-list-item-subtitle>
              <v-list-item-subtitle>{{ billingAddress.postal_code }} {{ billingAddress.city }}</v-list-item-subtitle>
              <v-list-item-subtitle v-if="billingAddress.country_code">
                {{ getTranslatedCountryName(billingAddress.country_code) }}
              </v-list-item-subtitle>
              <v-list-item-subtitle v-if="billingAddress.phone">{{ billingAddress.phone }}</v-list-item-subtitle>
              <v-list-item-subtitle v-if="billingAddress.last_four_digit_phone_number">
                {{ billingAddress.last_four_digit_phone_number }}
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-col>
      <v-col v-if="shippingAddress" className="pa-0" md="4" sm="6">
        <v-list>
          <v-list-item>
            <v-list-item-content>
              <v-list-item-title class="d-flex align-center">
                <div class="overflow-hidden overflow-ellipsis">{{ $t('order.shippingAddress') }}</div>
                <div v-if="canModifyAddress" class="pl-2">
                  <v-btn
                    icon
                    x-small
                    @click="showForm(shippingAddress, $t('order.shippingAddress'), 'shipping_address')"
                  >
                    <v-icon>mdi-pencil</v-icon>
                  </v-btn>
                </div>
              </v-list-item-title>
              <v-list-item-subtitle v-if="shippingAddress.company">{{ shippingAddress.company }}</v-list-item-subtitle>
              <v-list-item-subtitle v-if="shippingAddress.first_name && shippingAddress.last_name">
                <span v-if="shippingAddress.civility">{{ getCivilityTranslation(shippingAddress.civility) }}</span>
                {{ shippingAddress.first_name }} {{ shippingAddress.last_name }}
              </v-list-item-subtitle>
              <v-list-item-subtitle>{{ shippingAddress.street_1 }}</v-list-item-subtitle>
              <v-list-item-subtitle v-if="shippingAddress.street_2">
                {{ shippingAddress.street_2 }}
              </v-list-item-subtitle>
              <v-list-item-subtitle v-if="shippingAddress.street_3">
                {{ shippingAddress.street_3 }}
              </v-list-item-subtitle>
              <v-list-item-subtitle>{{ shippingAddress.postal_code }} {{ shippingAddress.city }}</v-list-item-subtitle>
              <v-list-item-subtitle v-if="shippingAddress.country_code">
                {{ getTranslatedCountryName(shippingAddress.country_code) }}
              </v-list-item-subtitle>
              <v-list-item-subtitle v-if="shippingAddress.phone">{{ shippingAddress.phone }}</v-list-item-subtitle>
              <v-list-item-subtitle v-if="shippingAddress.last_four_digit_phone_number">
                {{ shippingAddress.last_four_digit_phone_number }}
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-col>
      <v-col v-if="pickingAddress" className="pa-0" md="4" sm="6">
        <v-list>
          <v-list-item>
            <v-list-item-content>
              <v-list-item-title>{{ $t('order.pickingAddress') }}</v-list-item-title>
              <v-list-item-subtitle v-if="pickingAddress.company">{{ pickingAddress.company }}</v-list-item-subtitle>
              <v-list-item-subtitle v-if="pickingAddress.last_name && pickingAddress.first_name">
                <span v-if="pickingAddress.civility">{{ getCivilityTranslation(pickingAddress.civility) }}</span>
                {{ pickingAddress.first_name }} {{ pickingAddress.last_name }}
              </v-list-item-subtitle>
              <v-list-item-subtitle>{{ pickingAddress.street_1 }}</v-list-item-subtitle>
              <v-list-item-subtitle v-if="pickingAddress.street_2">{{ pickingAddress.street_2 }}</v-list-item-subtitle>
              <v-list-item-subtitle v-if="pickingAddress.street_3">{{ pickingAddress.street_3 }}</v-list-item-subtitle>
              <v-list-item-subtitle>{{ pickingAddress.postal_code }} {{ pickingAddress.city }}</v-list-item-subtitle>
              <v-list-item-subtitle v-if="pickingAddress.country_code">
                {{ getTranslatedCountryName(pickingAddress.country_code) }}
              </v-list-item-subtitle>
              <v-list-item-subtitle v-if="pickingAddress.phone">{{ pickingAddress.phone }}</v-list-item-subtitle>
              <v-list-item-subtitle v-if="pickingAddress.last_four_digit_phone_number">
                {{ pickingAddress.last_four_digit_phone_number }}
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-col>
    </v-row>
    <address-dialog
      v-if="formValue"
      :key="formKey"
      v-model="showAddressDialog"
      :form-value="formValue"
      :address-type="addressType"
      :title="title"
      @close="close()"
      @validateForm="validateForm"
    />
    <customer-dialog
      v-if="formCustomerValues"
      :key="customerFormKey"
      v-model="showCustomerDialog"
      :form-value="formCustomerValues"
      :countryCode="shippingAddress?.country_code || billingAddress?.country_code"
      @close="closeCustomerDialog()"
      @validateForm="validateCustomerForm"
    />
  </div>
</template>

<script>
  import AddressDialog from '@/components/dialogs/AddressDialog'
  import CustomerDialog from '@/components/dialogs/CustomerDialog'
  import isoCountries from 'i18n-iso-countries'
  import countries from '../data/countries'
  import { EventBus } from '../event-bus'

  export default {
    name: 'CustomerDetailBar',
    components: { AddressDialog, CustomerDialog },
    props: {
      customer: {
        type: Object,
        required: true,
      },
      billingAddress: {
        type: Object,
        required: false,
      },
      shippingAddress: {
        type: Object,
        required: false,
      },
      pickingAddress: {
        type: Object,
        required: false,
      },
      canModifyAddress: {
        type: Boolean,
        default: false,
        required: false,
      },
      canModifyCustomer: {
        type: Boolean,
        default: false,
        required: false,
      },
    },
    data() {
      return {
        showAddressDialog: false,
        formValue: null,
        title: null,
        addressType: null,
        formKey: Date.now(),
        countries: [],
        customerFormKey: Date.now(),
        formCustomerValues: null,
        showCustomerDialog: false,
      }
    },
    mounted() {
      isoCountries.registerLocale(require(`i18n-iso-countries/langs/${this.locale}.json`))
      this.countries = countries.map((country) => {
        let localeCountry = Object.assign({}, country)
        localeCountry.name = isoCountries.getName(country.iso_3_code, this.locale).toUpperCase()
        return localeCountry
      })
    },
    computed: {
      isMobile() {
        return this.$vuetify.breakpoint.width < 650
      },
      civility() {
        return [
          { value: 'mr', text: this.$t('order.mr') },
          { value: 'mrs', text: this.$t('order.mrs') },
        ]
      },
      locale() {
        return this.$i18n.locale
      },
      isDigitalInStoreEnabled() {
        return this.$store.state.partnerSettings.digital_in_store_access?.enabled
      },
    },
    methods: {
      close() {
        this.showAddressDialog = false
      },
      showForm(formValue, title, addressType) {
        this.formKey = Date.now()
        this.showAddressDialog = true
        this.formValue = formValue
        this.title = title
        this.addressType = addressType
      },
      validateForm(values) {
        this.$emit('validateForm', values)
        this.close()
      },
      getCivilityTranslation(civility) {
        let civilityTranslation = this.civility.find((item) => item.value === civility)
        if (civilityTranslation) {
          return civilityTranslation.text
        } else {
          return civility
        }
      },
      getTranslatedCountryName(countryCode) {
        const country = this.countries.find((item) => item.iso_3_code === countryCode)
        if (country) {
          return country.name
        }
      },
      openClient(email) {
        EventBus.$emit('openDigitalInStore', `#/customers/?email=${email}`)
      },
      showCustomerForm(formValue) {
        this.customerFormKey = Date.now()
        this.formCustomerValues = formValue
        this.showCustomerDialog = true
      },
      validateCustomerForm(values) {
        this.$emit('validateCustomerForm', values)
        this.closeCustomerDialog()
      },
      closeCustomerDialog() {
        this.showCustomerDialog = false
      },
    },
  }
</script>

<style scoped>
  .overflow-ellipsis {
    text-overflow: ellipsis;
  }
</style>
